module.exports = __webpack_public_path__ + "img/thumb-pesto-gnocchi.1ef41a10.jpg";